(function () {
  'use strict';
  const configNode = document.getElementById('gp-config');
  if (!configNode || !window.GPlateRules) return;
  const config = JSON.parse(configNode.textContent);
  const rules = window.GPlateRules;
  const money = (cents) => new Intl.NumberFormat('de-DE', { style: 'currency', currency: config.launchReady ? config.currency || 'EUR' : 'EUR' }).format(cents / 100);
  const cartUrl = `${config.root}cart`;
  const toast = (message) => {
    const box = document.querySelector('.gp-toast');
    if (!box) return;
    box.textContent = message;
    box.hidden = false;
    window.setTimeout(() => { box.hidden = true; }, 6000);
  };
  const readCart = async () => {
    const response = await fetch(`${config.root}cart.js`, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Der Warenkorb konnte nicht geladen werden. Bitte lade die Seite neu.');
    return response.json();
  };

  document.querySelectorAll('[data-open-dialog]').forEach((button) => {
    button.addEventListener('click', () => {
      const dialog = document.getElementById(button.dataset.openDialog);
      if (!dialog) return;
      dialog.showModal();
      dialog.addEventListener('close', () => button.focus(), { once: true });
      dialog.querySelector('input')?.focus();
    });
  });
  document.querySelectorAll('dialog').forEach((dialog) => {
    dialog.querySelectorAll('[data-close-dialog], nav a').forEach((button) => button.addEventListener('click', () => dialog.close()));
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
  });

  function showMedia(gallery, id) {
    if (!gallery || !Array.from(gallery.querySelectorAll('[data-gallery-media]')).some((media) => media.dataset.galleryMedia === String(id))) return;
    gallery.querySelectorAll('[data-gallery-media]').forEach((media) => {
      media.hidden = media.dataset.galleryMedia !== String(id);
      if (media.hidden) media.querySelector('video')?.pause();
    });
    gallery.querySelectorAll('[data-gallery-target]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.galleryTarget === String(id))));
  }
  document.querySelectorAll('[data-gallery]').forEach((gallery) => {
    gallery.querySelectorAll('[data-gallery-target]').forEach((button) => button.addEventListener('click', () => showMedia(gallery, button.dataset.galleryTarget)));
  });

  document.querySelectorAll('[data-catalog-section]').forEach((section) => {
    const grid = section.querySelector('[data-catalog-grid]');
    const cards = Array.from(grid?.querySelectorAll('[data-catalog-card]') || []);
    cards.forEach((card, index) => { card.dataset.order = index; });
    const update = () => {
      const filter = section.querySelector('[data-catalog-filter]')?.value || '';
      const sort = section.querySelector('[data-catalog-sort]')?.value || 'manual';
      cards.forEach((card) => { card.hidden = filter && !card.dataset.search.includes(filter); });
      cards.sort((a, b) => {
        if (sort === 'title') return a.dataset.title.localeCompare(b.dataset.title, 'de');
        if (sort.startsWith('price')) return (Number(a.dataset.price) - Number(b.dataset.price)) * (sort === 'price-desc' ? -1 : 1);
        return Number(a.dataset.order) - Number(b.dataset.order);
      });
      cards.forEach((card) => grid.appendChild(card));
      const empty = section.querySelector('[data-catalog-empty]');
      if (empty) empty.hidden = cards.some((card) => !card.hidden);
    };
    section.querySelectorAll('select').forEach((select) => select.addEventListener('change', update));
  });

  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const form = section.querySelector('[data-product-form]');
    const dataNode = section.querySelector('[data-product-data]');
    if (!form || !dataNode) return;
    const data = JSON.parse(dataNode.textContent);
    const select = form.querySelector('[data-variant-id]');
    const quantityInput = form.querySelector('[data-product-quantity]');
    const button = form.querySelector('[data-add-button]');
    const error = form.querySelector('[data-form-error]');
    const isPlate = section.dataset.kind === 'plate';
    let currentVariant = data.variants.find((variant) => String(variant.id) === String(select.value));
    let pending = false;
    quantityInput.removeAttribute('max');
    if (section.querySelector('[data-enhanced-options]')) {
      section.querySelector('[data-enhanced-options]').hidden = false;
      section.querySelector('[data-native-variant-wrap]').hidden = true;
    } else if (data.variants.length === 1) section.querySelector('[data-native-variant-wrap]').hidden = true;
    const selectionItem = () => ({ productId: Number(section.dataset.productId), title: data.title, variant: currentVariant?.title || '', quantity: rules.quantity(quantityInput.value), properties: Object.fromEntries(Array.from(new FormData(form)).filter(([key]) => key.startsWith('properties[')).map(([key, value]) => [key.slice(11, -1), value])), url: data.url });
    const updatePrice = () => {
      const count = rules.quantity(quantityInput.value);
      const quoteOnly = isPlate && count > 10;
      const displayUnit = !config.launchReady ? (isPlate ? 5995 : 336) : currentVariant?.price || 0;
      section.querySelector('[data-product-price]').textContent = money(displayUnit);
      const total = isPlate && (!config.launchReady || config.currency === 'EUR') ? rules.plateTotal(count) : count && displayUnit * count;
      section.querySelector('[data-selection-price]').textContent = quoteOnly ? 'Individuelles Angebot' : count && total !== null ? money(total) : 'Bitte Menge prüfen';
      section.querySelector('[data-selection-label]').textContent = config.launchReady && config.currency !== 'EUR' ? 'Preis vor Mengenrabatt' : isPlate ? 'Staffelpreis dieser Auswahl' : 'Preis dieser Auswahl';
      button.textContent = !currentVariant?.available ? 'Ausverkauft' : quoteOnly ? 'Angebot per WhatsApp anfragen' : 'In den Warenkorb';
      button.disabled = pending || !currentVariant?.available || !count;
      form.querySelectorAll('[data-quantity-preset]').forEach((preset) => preset.setAttribute('aria-pressed', String(Number(preset.dataset.quantityPreset) === count)));
      const quoteLink = section.querySelector('[data-large-quantity-link]');
      if (quoteLink) quoteLink.href = rules.quoteUrl(config.whatsapp, [{ ...selectionItem(), quantity: Math.max(count || 11, 11) }], 'Hallo GPlate, bitte erstellt mir ein individuelles Angebot für eine größere Menge:', config.shopUrl);
    };
    form.querySelectorAll('[data-option-position]').forEach((radio) => radio.addEventListener('change', () => {
      const options = Array.from(form.querySelectorAll('[data-option-position]:checked')).sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)).map((input) => input.value);
      currentVariant = data.variants.find((variant) => variant.options.every((value, i) => value === options[i]));
      select.value = currentVariant?.id || '';
      error.hidden = Boolean(currentVariant);
      if (!currentVariant) error.textContent = 'Diese Kombination ist nicht verfügbar. Bitte wähle eine andere Variante.';
      if (currentVariant) {
        const url = new URL(location.href);
        url.searchParams.set('variant', currentVariant.id);
        history.replaceState(null, '', url);
        if (currentVariant.mediaId) showMedia(section.querySelector('[data-gallery]'), currentVariant.mediaId);
      }
      updatePrice();
    }));
    select.addEventListener('change', () => { currentVariant = data.variants.find((v) => String(v.id) === select.value); updatePrice(); });
    quantityInput.addEventListener('input', updatePrice);
    form.querySelectorAll('[data-quantity-preset]').forEach((preset) => preset.addEventListener('click', () => { quantityInput.value = preset.dataset.quantityPreset; updatePrice(); }));
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (pending || !form.reportValidity() || !currentVariant?.available) return;
      const count = rules.quantity(quantityInput.value);
      if (!count) return;
      pending = true;
      error.hidden = true;
      updatePrice();
      try {
        if (isPlate) {
          const cart = await readCart();
          if (rules.plateCount(cart.items) + count > 10) {
            const items = cart.items.map((item) => ({ ...item, url: item.url?.split('?')[0] }));
            const link = rules.quoteUrl(config.whatsapp, [...items, selectionItem()], undefined, config.shopUrl);
            // Only the customer's explicit quotation click opens WhatsApp.
            if (count > 10) { location.assign(link); return; }
            error.textContent = 'Mit dieser Auswahl wären mehr als zehn Platten im Warenkorb. Bitte reduziere die Menge oder nutze „Mehr als 10 Stück anfragen“ für ein persönliches Angebot.';
            const quoteLink = section.querySelector('[data-large-quantity-link]');
            quoteLink.href = link;
            error.hidden = false;
            return;
          }
        }
        const body = new FormData(form);
        const response = await fetch(`${config.root}cart/add.js`, { method: 'POST', body, credentials: 'same-origin', headers: { Accept: 'application/json' } });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Die Auswahl konnte nicht hinzugefügt werden. Bitte prüfe Variante und Menge.');
        location.assign(cartUrl);
      } catch (failure) {
        error.textContent = failure.message || 'Die Verbindung wurde unterbrochen. Bitte prüfe den Warenkorb, bevor du erneut hinzufügst.';
        error.hidden = false;
      } finally {
        pending = false;
        updatePrice();
      }
    });
    updatePrice();
    if ((new URL(location.href).searchParams.has('variant') || Number(section.dataset.productId) === 9684666745100) && currentVariant?.mediaId) showMedia(section.querySelector('[data-gallery]'), currentVariant.mediaId);
  });

  const cartData = document.querySelector('[data-cart-data]');
  const cartQuote = document.querySelector('[data-cart-quote]');
  if (cartData && cartQuote) cartQuote.href = rules.quoteUrl(config.whatsapp, JSON.parse(cartData.textContent).items, undefined, config.shopUrl);
  const cartForm = document.querySelector('[data-cart-form]');
  if (cartForm) {
    const check = cartForm.querySelector('[name="attributes[Geschäftskunde]"]');
    // An update/removal never requires the business confirmation.
    cartForm.addEventListener('submit', (event) => {
      if (check) check.required = event.submitter?.name === 'checkout';
    });
    cartForm.querySelectorAll('[data-cart-quantity]').forEach((input) => input.addEventListener('change', () => {
      if (check) check.required = false;
      cartForm.requestSubmit(cartForm.querySelector('[data-cart-update]'));
    }));
  }

  document.querySelectorAll('[data-address-country]').forEach((select) => { select.value = select.dataset.default; });
  const privacyDialog = document.getElementById('gp-privacy-dialog');
  const privacyForm = privacyDialog?.querySelector('[data-privacy-form]');
  const showPrivacy = () => {
    const consent = window.Shopify?.customerPrivacy?.currentVisitorConsent?.() || {};
    for (const category of ['analytics', 'marketing', 'preferences']) privacyForm.elements[category].checked = consent[category] === 'yes';
    privacyDialog.showModal();
  };
  document.querySelectorAll('[data-privacy-settings]').forEach((button) => button.addEventListener('click', () => {
    if (window.privacyBanner?.showPreferences) window.privacyBanner.showPreferences().catch(showPrivacy);
    else showPrivacy();
  }));
  const savePrivacy = (necessaryOnly) => {
    const status = privacyForm.querySelector('[data-privacy-status]');
    const api = window.Shopify?.customerPrivacy;
    if (!api?.setTrackingConsent) { status.textContent = 'Die Verbindung zu Shopify ist noch nicht bereit. Bitte versuche es gleich erneut.'; return; }
    const consent = { analytics: !necessaryOnly && privacyForm.elements.analytics.checked, marketing: !necessaryOnly && privacyForm.elements.marketing.checked, preferences: !necessaryOnly && privacyForm.elements.preferences.checked, sale_of_data: false };
    api.setTrackingConsent(consent, (error) => {
      if (error) { status.textContent = 'Deine Auswahl konnte nicht gespeichert werden. Bitte versuche es erneut.'; return; }
      try { sessionStorage.setItem('gp-privacy-choice-saved', '1'); } catch (_) { /* Browser storage can be unavailable. */ }
      privacyDialog.close();
      toast('Deine Cookie-Einstellungen wurden gespeichert.');
    });
  };
  privacyForm?.addEventListener('submit', (event) => { event.preventDefault(); savePrivacy(false); });
  privacyForm?.querySelector('[data-privacy-reject]')?.addEventListener('click', () => savePrivacy(true));
  // Optional GA4 is intentionally absent until a merchant supplies an ID.
  // Native Shopify customer events remain managed by Shopify itself.
  let gaStarted = false;
  const syncAnalytics = () => {
    if (!/^G-[A-Z0-9]+$/.test(config.gaId || '')) return;
    const allowed = window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
    if (window.gtag) window.gtag('consent', 'update', { analytics_storage: allowed ? 'granted' : 'denied' });
    if (!allowed || gaStarted) return;
    gaStarted = true;
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    window.gtag('consent', 'default', { analytics_storage: 'granted', ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied' });
    window.gtag('js', new Date());
    window.gtag('config', config.gaId);
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(config.gaId)}`;
    document.head.appendChild(script);
  };
  document.addEventListener('visitorConsentCollected', syncAnalytics);
  if (window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
    if (error) return;
    syncAnalytics();
    let savedThisSession = false;
    try { savedThisSession = sessionStorage.getItem('gp-privacy-choice-saved') === '1'; } catch (_) { /* Use Shopify consent state. */ }
    if (!savedThisSession && !window.privacyBanner && window.Shopify.customerPrivacy?.shouldShowBanner?.() && !document.querySelector('dialog[open]')) showPrivacy();
  });
})();
